import { useEffect, useState } from "react";
import axios from "axios";
import { GraduationCap, Mail, Loader2 } from "lucide-react";
import { TL } from "../content/talentI18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MyMentor({ lang, auth }) {
  const L = TL[lang] || TL.sk;
  const [p, setP] = useState(null);
  useEffect(() => { axios.get(`${API}/applicant/profile`, auth()).then(({ data }) => setP(data)).catch(() => setP({})); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!p) return <Loader2 className="animate-spin text-white/40" />;
  const m = p.mentor;
  return (
    <div className="border border-[#D4AF37]/30 bg-gradient-to-b from-[#D4AF37]/[0.06] to-transparent p-6" data-testid="my-mentor">
      <h3 className="font-display text-xl flex items-center gap-2 mb-4"><GraduationCap size={20} className="text-[#D4AF37]" /> {L.mentorTitle}</h3>
      {m ? (
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#F2E3C6] to-[#D4AF37] text-black font-display text-lg flex items-center justify-center shrink-0">
            {(m.name || "?").split(" ").map((x) => x[0]).slice(0, 2).join("")}
          </div>
          <div className="min-w-0">
            <p className="text-white text-lg" data-testid="my-mentor-name">{m.name}</p>
            {m.mentor_certificate_no && <p className="text-[#D4AF37] text-xs font-mono">{m.mentor_certificate_no}</p>}
            {m.assigned_at && <p className="text-white/40 text-xs mt-1">{L.mentorSince}: {new Date(m.assigned_at).toLocaleDateString("sk-SK")}</p>}
            <a href={`mailto:${m.email}`} data-testid="my-mentor-email" className="inline-flex items-center gap-1.5 text-[#D4AF37] text-sm mt-2 hover:underline"><Mail size={14} /> {L.mentorWrite}</a>
          </div>
        </div>
      ) : <p className="text-white/50 text-sm" data-testid="my-mentor-none">{L.mentorNone}</p>}
    </div>
  );
}
